import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'

import { SavePackageConfigRequest } from '../entities/SavePackageConfigRequest';

@Injectable()
export class DomainDataService {

    //#region URLs
    private headers = new Headers({ 'Content-Type': 'application/json' });
    private baseDomainDataUrl = "/DomainData";  // URL to web api
    private getAppSettingsURL = '';
    private getUserMessagesURL = '';
    private getAccountStatementTypesURL = '';
    private getAttachmentTypesURL = '';
    private getBusinessDayURL = '';
    private getClerksURL = '';
    private getDunningProceduresURL = '';
    private getDunningBlocksURL = '';
    private getEligibilityIndicatorsURL = '';
    private getPaymentOptionsURL = '';
    private getSelectionRulesURL = '';
    private getUpdateNeededsURL = '';
    private getPayerTypesURL = '';
    private getCompletionNumberLabelsURL = '';
    private getMerchLevelsURL = '';
    private getMerchPercentagesURL = '';
    private getPalletTypesURL = '';
    private getPaymentTermsURL = '';
    private getPrimaryGroupOverridesURL = '';
    private getTimeProfilesURL = '';
    private getBusinessTypesURL = '';
    private getCallFrequenciesURL = '';
    private getCommissionPaymentFrequenciesURL = '';
    private getSubtradeChannelsURL = '';
    private getDistributionModesURL = '';
    private getMonthsURL = '';
    private getKeyAccountsURL = '';
    private getTradeGroupsURL = '';
    private getTradeNamesURL = '';
    private getOrderMethodsURL = '';
    private getOrderFrequenciesURL = '';
    private getSpecialEventFrequenciesURL = '';
    private getSpecialEventTypesURL = '';
    private getVendPackagesURL = '';
    private getSpecificModelReasonsURL = '';
    private getEquipmentActivitiesURL = '';
    private getEquipmentCategoriesURL = '';
    private getEquipmentLineItemTypesURL = '';
    private getEquipmentTypesURL = '';
    private getModelGroupsURL = '';
    private getModelsURL = '';
    private getEquipmentGraphicsURL = '';
    private getVendSizesURL = '';
    private getFlavorsURL = '';
    private getCardReadersURL = '';
    private getSecurityLevelsURL = '';
    private getLineTypesURL = '';
    private getLineRunLocationsURL = '';
    private getSuppressionReasonsURL = '';
    private getFamilyTypesURL = '';
    private getSwapReasonsURL = '';
    private getEquipmentClassesURL = '';
    private getActivityReasonsURL = '';
    private getSalesOfficesURL = '';
    private getSalesOfficeTypesURL = '';
    private getStatesURL = '';
    private getDaysOfWeekURL = '';
    private getRequestTypesURL = '';
    private getRequestStatusesURL = '';
    private getFeaturesURL = '';
    private getShelfDirectionsURL = '';
    private getProductSizesURL = '';
    private getGlideTypesURL = '';
    private getManagedBysURL = '';
    private getGlobalCustomersURL = '';
    private getFullServiceCustomerTypesURL = '';
    private getFullServicePricingTypesURL = '';
    private getPackageConfigsURL = '';
    private getMassUpdateEntitiesURL = '';
    private getDelayBetweenSalesAndDeliveriesURL = '';
    private getSectionsURL = '';
    private getVendSizeFlavorXrefsURL = '';
    private getTablesURL = '';
    private getTableAttributesURL = '';
    private getDomainRecordsURL = '';
    private getValidationsURL = '';
    private getValidationTypesURL = '';
    private getContactDepartmentsURL = '';
    private getContactFunctionsURL = '';
    private getContactValidationsURL = '';
    private getCoolerDoorsURL = '';
    private getCoolerStylesURL = '';
    private getCreditHoldActionsURL = '';
    private getCustomerOwnershipsURL = '';
    private getCustomerTypesURL = '';
    private getApprovalTypesURL = '';
    private getMasterDeliveryRoutesURL = '';
    private getBillingDiscrepancyRequestTypesURL = '';
    private getBillingDiscrepancyRequestReasonsURL = '';
    private getBillingActionsURL = '';
    private getCustomerPaymentTypesURL = '';
    private getCustomerRoiToolsURL = '';
    private getOutletAcquisitionTypesURL = '';
    private getProspectSourcesURL = '';

    private saveActivityReasonURL = '';
    private saveContactValidationURL = '';
    private saveKeyAccountURL = '';
    private saveModelURL = '';
    private saveModelGroupURL = '';
    private savePrimaryGroupOverrideURL = '';
    private saveRequestTypeURL = '';
    private saveSalesOfficeURL = '';
    private saveVendSizeFlavorXrefURL = '';
    private savePackageConfigURL = '';
    private saveDomainRecordsURL = '';

    //#endregion


    appConfig: ent.AppConfig;

    constructor(private http: Http, private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseDomainDataUrl = this.configService.appConfig.UrlBase + this.baseDomainDataUrl;

        //#region initialize URLs
        this.getAppSettingsURL = this.baseDomainDataUrl + '/GetAppSettings';
        this.getUserMessagesURL = this.baseDomainDataUrl + '/GetUserMessages';
        this.getAccountStatementTypesURL = this.baseDomainDataUrl + '/GetAccountStatementTypes';
        this.getAttachmentTypesURL = this.baseDomainDataUrl + '/GetAttachmentTypes';
        this.getBusinessDayURL = this.baseDomainDataUrl + '/GetBusinessDay';
        this.getCompletionNumberLabelsURL = this.baseDomainDataUrl + '/GetCompletionNumberLabels';
        this.getClerksURL = this.baseDomainDataUrl + '/GetClerks';
        this.getDunningProceduresURL = this.baseDomainDataUrl + '/GetDunningProcedures';
        this.getDunningBlocksURL = this.baseDomainDataUrl + '/GetDunningBlocks';
        this.getEligibilityIndicatorsURL = this.baseDomainDataUrl + '/GetEligibilityIndicators';
        this.getPaymentOptionsURL = this.baseDomainDataUrl + '/GetPaymentOptions';
        this.getSelectionRulesURL = this.baseDomainDataUrl + '/GetSelectionRules';
        this.getUpdateNeededsURL = this.baseDomainDataUrl + '/GetUpdateNeededs';
        this.getPayerTypesURL = this.baseDomainDataUrl + '/GetPayerTypes';
        this.getMerchLevelsURL = this.baseDomainDataUrl + '/GetMerchLevels';
        this.getMerchPercentagesURL = this.baseDomainDataUrl + '/GetMerchPercentages';
        this.getPalletTypesURL = this.baseDomainDataUrl + '/GetPalletTypes';
        this.getPaymentTermsURL = this.baseDomainDataUrl + '/GetPaymentTerms';
        this.getPrimaryGroupOverridesURL = this.baseDomainDataUrl + '/GetPrimaryGroupOverrides';
        this.getTimeProfilesURL = this.baseDomainDataUrl + '/GetTimeProfiles';
        this.getBusinessTypesURL = this.baseDomainDataUrl + '/GetBusinessTypes';
        this.getCallFrequenciesURL = this.baseDomainDataUrl + '/GetCallFrequencies';
        this.getCommissionPaymentFrequenciesURL = this.baseDomainDataUrl + '/GetCommissionPaymentFrequencies';
        this.getSubtradeChannelsURL = this.baseDomainDataUrl + '/GetSubtradeChannels';
        this.getDistributionModesURL = this.baseDomainDataUrl + '/GetDistributionModes';
        this.getMonthsURL = this.baseDomainDataUrl + '/GetMonths';
        this.getKeyAccountsURL = this.baseDomainDataUrl + '/GetKeyAccounts';
        this.getTradeGroupsURL = this.baseDomainDataUrl + '/GetTradeGroups';
        this.getTradeNamesURL = this.baseDomainDataUrl + '/GetTradeNames';
        this.getOrderMethodsURL = this.baseDomainDataUrl + '/GetOrderMethods';
        this.getOrderFrequenciesURL = this.baseDomainDataUrl + '/GetOrderFrequencies';
        this.getSpecialEventFrequenciesURL = this.baseDomainDataUrl + '/GetSpecialEventFrequencies';
        this.getSpecialEventTypesURL = this.baseDomainDataUrl + '/GetSpecialEventTypes';
        this.getVendPackagesURL = this.baseDomainDataUrl + '/GetVendPackages';
        this.getSpecificModelReasonsURL = this.baseDomainDataUrl + '/GetSpecificModelReasons';
        this.getEquipmentActivitiesURL = this.baseDomainDataUrl + '/GetEquipmentActivities';
        this.getEquipmentCategoriesURL = this.baseDomainDataUrl + '/GetEquipmentCategories';
        this.getEquipmentLineItemTypesURL = this.baseDomainDataUrl + '/GetEquipmentLineItemTypes';
        this.getEquipmentTypesURL = this.baseDomainDataUrl + '/GetEquipmentTypes';
        this.getModelGroupsURL = this.baseDomainDataUrl + '/GetModelGroups';
        this.getModelsURL = this.baseDomainDataUrl + '/GetModels';
        this.getEquipmentGraphicsURL = this.baseDomainDataUrl + '/GetEquipmentGraphics';
        this.getVendSizesURL = this.baseDomainDataUrl + '/GetVendSizes';
        this.getFlavorsURL = this.baseDomainDataUrl + '/GetFlavors';
        this.getCardReadersURL = this.baseDomainDataUrl + '/GetCardReaders';
        this.getSecurityLevelsURL = this.baseDomainDataUrl + '/GetSecurityLevels';
        this.getLineTypesURL = this.baseDomainDataUrl + '/GetLineTypes';
        this.getLineRunLocationsURL = this.baseDomainDataUrl + '/GetLineRunLocations';
        this.getSuppressionReasonsURL = this.baseDomainDataUrl + '/GetSuppressionReasons';
        this.getFamilyTypesURL = this.baseDomainDataUrl + '/GetFamilyTypes';
        this.getSwapReasonsURL = this.baseDomainDataUrl + '/GetSwapReasons';
        this.getEquipmentClassesURL = this.baseDomainDataUrl + '/GetEquipmentClasses';
        this.getActivityReasonsURL = this.baseDomainDataUrl + '/GetActivityReasons';
        this.getSalesOfficesURL = this.baseDomainDataUrl + '/GetSalesOffices';
        this.getSalesOfficeTypesURL = this.baseDomainDataUrl + '/GetSalesOfficeTypes';
        this.getStatesURL = this.baseDomainDataUrl + '/GetStates';
        this.getDaysOfWeekURL = this.baseDomainDataUrl + '/GetDaysOfWeek';
        this.getRequestTypesURL = this.baseDomainDataUrl + '/GetRequestTypes';
        this.getRequestStatusesURL = this.baseDomainDataUrl + '/GetRequestStatuses';
        this.getFeaturesURL = this.baseDomainDataUrl + '/GetFeatures';
        this.getShelfDirectionsURL = this.baseDomainDataUrl + '/GetShelfDirections';
        this.getProductSizesURL = this.baseDomainDataUrl + '/GetProductSizes';
        this.getGlideTypesURL = this.baseDomainDataUrl + '/GetGlideTypes';
        this.getManagedBysURL = this.baseDomainDataUrl + '/GetManagedBys';
        this.getGlobalCustomersURL = this.baseDomainDataUrl + '/GetGlobalCustomers';
        this.getFullServiceCustomerTypesURL = this.baseDomainDataUrl + '/GetFullServiceCustomerTypes';
        this.getFullServicePricingTypesURL = this.baseDomainDataUrl + '/GetFullServicePricingTypes';
        this.getPackageConfigsURL = this.baseDomainDataUrl + '/GetPackageConfigs';
        this.getMassUpdateEntitiesURL = this.baseDomainDataUrl + '/GetMassUpdateEntities';
        this.getDelayBetweenSalesAndDeliveriesURL = this.baseDomainDataUrl + '/GetDelayBetweenOrderAndDeliveries';
        this.getSectionsURL = this.baseDomainDataUrl + '/GetSections';
        this.getVendSizeFlavorXrefsURL = this.baseDomainDataUrl + '/GetVendSizeFlavorXrefs';
        this.getTablesURL = this.baseDomainDataUrl + '/GetTables';
        this.getTableAttributesURL = this.baseDomainDataUrl + '/GetTableAttributes';
        this.getDomainRecordsURL = this.baseDomainDataUrl + '/GetDomainRecords';
        this.getValidationsURL = this.baseDomainDataUrl + '/GetValidations';
        this.getValidationTypesURL = this.baseDomainDataUrl + '/GetValidationTypes';
        this.getContactDepartmentsURL = this.baseDomainDataUrl + '/GetContactDepartments';
        this.getContactFunctionsURL = this.baseDomainDataUrl + '/GetContactFunctions';
        this.getContactValidationsURL = this.baseDomainDataUrl + '/GetContactValidations';
        this.getCoolerDoorsURL = this.baseDomainDataUrl + '/GetCoolerDoors';
        this.getCoolerStylesURL = this.baseDomainDataUrl + '/GetCoolerStyles';
        this.getCreditHoldActionsURL = this.baseDomainDataUrl + '/GetCreditHoldActions';
        this.getCustomerOwnershipsURL = this.baseDomainDataUrl + '/GetCustomerOwnerships';
        this.getCustomerTypesURL = this.baseDomainDataUrl + '/GetCustomerTypes';
        this.getApprovalTypesURL = this.baseDomainDataUrl + '/GetApprovalTypes';
        this.getMasterDeliveryRoutesURL = this.baseDomainDataUrl + '/GetMasterDeliveryRoutes';
        this.getBillingDiscrepancyRequestTypesURL = this.baseDomainDataUrl + '/GetBillingDiscrepancyRequestTypes';
        this.getBillingDiscrepancyRequestReasonsURL = this.baseDomainDataUrl + '/GetBillingDiscrepancyRequestReasons';
        this.getBillingActionsURL = this.baseDomainDataUrl + '/GetBillingActions';
        this.getCustomerPaymentTypesURL = this.baseDomainDataUrl + '/GetCustomerPaymentTypes';
        this.getCustomerRoiToolsURL = this.baseDomainDataUrl + '/GetCustomerRoiTools';
        this.getOutletAcquisitionTypesURL = this.baseDomainDataUrl + '/GetOutletAcquisitionTypes';
        this.getProspectSourcesURL = this.baseDomainDataUrl + '/GetProspectSources';
        this.saveActivityReasonURL = this.baseDomainDataUrl + '/SaveActivityReason';
        this.saveContactValidationURL = this.baseDomainDataUrl + '/SaveContactValidation';
        this.saveKeyAccountURL = this.baseDomainDataUrl + '/SaveKeyAccount';
        this.saveModelURL = this.baseDomainDataUrl + '/SaveModel';
        this.saveModelGroupURL = this.baseDomainDataUrl + '/SaveModelGroup';
        this.savePrimaryGroupOverrideURL = this.baseDomainDataUrl + '/SavePrimaryGroupOverride';
        this.saveRequestTypeURL = this.baseDomainDataUrl + '/SaveRequestType';
        this.saveSalesOfficeURL = this.baseDomainDataUrl + '/SaveSalesOffice';
        this.saveVendSizeFlavorXrefURL = this.baseDomainDataUrl + '/SaveVendSizeFlavorXref';
        this.savePackageConfigURL = this.baseDomainDataUrl + '/SavePackageConfig';
        this.saveDomainRecordsURL = this.baseDomainDataUrl + '/SaveDomainRecords';
        //#endregion

    }

    //#region Get Methods
    getAppSettings(): Observable<ent.AppSetting[]> {
        return this.httpClient.get<ent.AppSetting[]>(this.getAppSettingsURL);
    }

    getUserMessages(request: ent.GetDataRequest): Observable<ent.UserMessage[]> {
        return this.httpClient.post<ent.UserMessage[]>(this.getUserMessagesURL, request);
    }
    
    getAccountStatementTypes(filter: filters.AccountStatementTypeFilter): Observable<ent.AccountStatementType[]> {
        return this.httpClient.post<ent.AccountStatementType[]>(this.getAccountStatementTypesURL, filter);
    }

    getAttachmentTypes(filter: filters.AttachmentTypeFilter): Observable<ent.AttachmentType[]> {
        return this.httpClient.post<ent.AttachmentType[]>(this.getAttachmentTypesURL, filter);
    }

    getBusinessDay(request: ent.GetBusinessDayRequest): Observable<Date> {
        return this.httpClient.post<Date>(this.getBusinessDayURL, request);
    }

    getClerks(filter: filters.ClerkFilter): Observable<ent.Clerk[]> {
        return this.httpClient.post<ent.Clerk[]>(this.getClerksURL, filter);
    }

    getDunningProcedures(filter: filters.DunningProcedureFilter): Observable<ent.DunningProcedure[]> {
        return this.httpClient.post<ent.DunningProcedure[]>(this.getDunningProceduresURL, filter);
    }

    getDunningBlocks(filter: filters.DunningBlockFilter): Observable<ent.DunningBlock[]> {
        return this.httpClient.post<ent.DunningBlock[]>(this.getDunningBlocksURL, filter);
    }

    getEligibilityIndicators(filter: filters.EligibilityIndicatorFilter): Observable<ent.EligbilityIndicator[]> {
        return this.httpClient.post<ent.EligbilityIndicator[]>(this.getEligibilityIndicatorsURL, filter);
    }

    getPaymentOptions(filter: filters.PaymentOptionFilter): Observable<ent.PaymentOption[]> {
        return this.httpClient.post<ent.PaymentOption[]>(this.getPaymentOptionsURL, filter);
    }

    getSelectionRules(filter: filters.SelectionRuleFilter): Observable<ent.SelectionRule[]> {
        return this.httpClient.post<ent.SelectionRule[]>(this.getSelectionRulesURL, filter);
    }

    getUpdateNeededs(filter: filters.UpdateNeededFilter): Observable<ent.UpdateNeeded[]> {
        return this.httpClient.post<ent.UpdateNeeded[]>(this.getUpdateNeededsURL, filter);
    }

    getPayerTypes(filter: filters.PayerTypeFilter): Observable<ent.PayerType[]> {
        return this.httpClient.post<ent.PayerType[]>(this.getPayerTypesURL, filter);
    }

    getCompletionNumberLabels(filter: filters.CompletionNumberLabelFilter): Observable<ent.CompletionNumberLabel[]> {
        return this.httpClient.post<ent.CompletionNumberLabel[]>(this.getCompletionNumberLabelsURL, filter);
    }

    getMerchLevels(): Observable<ent.MerchLevel[]> {
        return this.httpClient.get<ent.MerchLevel[]>(this.getMerchLevelsURL);
    }

    getMerchPercentages(filter: filters.MerchPercentageFilter): Observable<ent.MerchPercentage[]> {
        return this.httpClient.post<ent.MerchPercentage[]>(this.getMerchPercentagesURL, filter);
    }

    getPalletTypes(filter: filters.PalletTypeFilter): Observable<ent.PalletType[]> {
        return this.httpClient.post<ent.PalletType[]>(this.getPalletTypesURL, filter);
    }

    getPaymentTerms(filter: filters.PaymentTermsFilter): Observable<ent.PaymentTerm[]> {
        return this.httpClient.post<ent.PaymentTerm[]>(this.getPaymentTermsURL, filter);
    }

    getPrimaryGroupOverrides(): Observable<ent.PrimaryGroupOverride[]> {
        return this.httpClient.get<ent.PrimaryGroupOverride[]>(this.getPrimaryGroupOverridesURL);
    }

    getTimeProfiles(): Observable<ent.TimeProfile[]> {
        return this.httpClient.get<ent.TimeProfile[]>(this.getTimeProfilesURL);
    }

    getBusinessTypes(): Observable<ent.BusinessType[]> {
        return this.httpClient.get<ent.BusinessType[]>(this.getBusinessTypesURL);
    }

    getCallFrequencies(): Observable<ent.CallFrequency[]> {
        return this.httpClient.get<ent.CallFrequency[]>(this.getCallFrequenciesURL);
    }

    getCommissionPaymentFrequencies(): Observable<ent.CommissionPaymentFrequency[]> {
        return this.httpClient.get<ent.CommissionPaymentFrequency[]>(this.getCommissionPaymentFrequenciesURL);
    }

    getSubtradeChannels(filter: filters.SubtradeChannelFilter): Observable<ent.SubtradeChannel[]> {
        return this.httpClient.post<ent.SubtradeChannel[]>(this.getSubtradeChannelsURL, filter);
    }

    getDistributionModes(filter: filters.DistributionModeFilter): Observable<ent.DistributionMode[]> {
        return this.httpClient.post<ent.DistributionMode[]>(this.getDistributionModesURL, filter);
    }

    getMonths(): Observable<ent.Month[]> {
        return this.httpClient.get<ent.Month[]>(this.getMonthsURL);
    }

    getKeyAccounts(filter: filters.KeyAccountFilter): Observable<ent.KeyAccount[]> {
        return this.httpClient.post<ent.KeyAccount[]>(this.getKeyAccountsURL, filter);
    }

    getTradeGroups(filter: filters.TradeGroupFilter): Observable<ent.TradeGroup[]> {
        return this.httpClient.post<ent.TradeGroup[]>(this.getTradeGroupsURL, filter);
    }

    getTradeNames(filter: filters.TradeNameFilter): Observable<ent.TradeName[]> {
        return this.httpClient.post<ent.TradeName[]>(this.getTradeNamesURL, filter);
    }

    getOrderMethods(): Observable<ent.OrderMethod[]> {
        return this.httpClient.get<ent.OrderMethod[]>(this.getOrderMethodsURL);
    }

    getOrderFrequencies(): Observable<ent.OrderFrequency[]> {
        return this.httpClient.get<ent.OrderFrequency[]>(this.getOrderFrequenciesURL);
    }

    getSpecialEventFrequencies(): Observable<ent.SpecialEventFrequency[]> {
        return this.httpClient.get<ent.SpecialEventFrequency[]>(this.getSpecialEventFrequenciesURL);
    }

    getSpecialEventTypes(): Observable<ent.SpecialEventType[]> {
        return this.httpClient.get<ent.SpecialEventType[]>(this.getSpecialEventTypesURL);
    }

    getVendPackages(filter: filters.VendPackageFilter): Observable<ent.VendPackage[]> {
        return this.httpClient.post<ent.VendPackage[]>(this.getVendPackagesURL, filter);
    }

    getSpecificModelReasons(): Observable<ent.SpecificModelReason[]> {
        return this.httpClient.get<ent.SpecificModelReason[]>(this.getSpecificModelReasonsURL);
    }

    getEquipmentActivities(): Observable<ent.EquipmentActivity[]> {
        return this.httpClient.get<ent.EquipmentActivity[]>(this.getEquipmentActivitiesURL);
    }

    getEquipmentCategories(): Observable<ent.EquipmentCategory[]> {
        return this.httpClient.get<ent.EquipmentCategory[]>(this.getEquipmentCategoriesURL);
    }

    getEquipmentLineItemTypes(): Observable<ent.EquipmentLineItemType[]> {
        return this.httpClient.get<ent.EquipmentLineItemType[]>(this.getEquipmentLineItemTypesURL);
    }

    getEquipmentTypes(): Observable<ent.EquipmentType[]> {
        return this.httpClient.get<ent.EquipmentType[]>(this.getEquipmentTypesURL);
    }

    getModelGroups(filter: filters.ModelGroupFilter): Observable<ent.ModelGroup[]> {
        return this.httpClient.post<ent.ModelGroup[]>(this.getModelGroupsURL, filter);
    }

    getModels(filter: filters.ModelFilter): Observable<ent.Model[]> {
        return this.httpClient.post<ent.Model[]>(this.getModelsURL, filter);
    }

    getEquipmentGraphics(filter: filters.EquipmentGraphicsFilter): Observable<ent.EquipmentGraphics[]> {
        return this.httpClient.post<ent.EquipmentGraphics[]>(this.getEquipmentGraphicsURL, filter);
    }

    getVendSizes(filter: filters.VendSizeFilter): Observable<ent.VendSize[]> {
        return this.httpClient.post<ent.VendSize[]>(this.getVendSizesURL, filter);
    }

    getFlavors(filter: filters.FlavorFilter): Observable<ent.Flavor[]> {
        return this.httpClient.post<ent.Flavor[]>(this.getFlavorsURL, filter);
    }

    getCardReaders(): Observable<ent.CardReader[]> {
        return this.httpClient.get<ent.CardReader[]>(this.getCardReadersURL);
    }

    getSecurityLevels(): Observable<ent.SecurityLevel[]> {
        return this.httpClient.get<ent.SecurityLevel[]>(this.getSecurityLevelsURL);
    }

    getLineTypes(filter: filters.LineTypeFilter): Observable<ent.LineType[]> {
        return this.httpClient.post<ent.LineType[]>(this.getLineTypesURL, filter);
    }

    getLineRunLocations(filter: filters.LineRunLocationFilter): Observable<ent.LineRunLocation[]> {
        return this.httpClient.post<ent.LineRunLocation[]>(this.getLineRunLocationsURL, filter);
    }

    getSuppressionReasons(filter: filters.SuppressionReasonFilter): Observable<ent.SuppressionReason[]> {
        return this.httpClient.post<ent.SuppressionReason[]>(this.getSuppressionReasonsURL, filter);
    }

    getFamilyTypes(filter: filters.FamilyTypeFilter): Observable<ent.FamilyType[]> {
        return this.httpClient.post<ent.FamilyType[]>(this.getFamilyTypesURL, filter);
    }

    getSwapReasons(): Observable<ent.SwapReason[]> {
        return this.httpClient.get<ent.SwapReason[]>(this.getSwapReasonsURL);
    }

    getEquipmentClasses(): Observable<ent.EquipmentClass[]> {
        return this.httpClient.get<ent.EquipmentClass[]>(this.getEquipmentClassesURL);
    }

    getActivityReasons(filter: filters.ActivityReasonFilter): Observable<ent.ActivityReason[]> {
        return this.httpClient.post<ent.ActivityReason[]>(this.getActivityReasonsURL, filter);
    }

    getSalesOffices(filter: filters.SalesOfficeFilter): Observable<ent.SalesOffice[]> {
        return this.httpClient.post<ent.SalesOffice[]>(this.getSalesOfficesURL, filter);
    }

    getSalesOfficeTypes(): Observable<ent.SalesOfficeType[]> {
        return this.httpClient.get<ent.SalesOfficeType[]>(this.getSalesOfficeTypesURL);
    }

    getSalesOfficesFromCache(filter: filters.SalesOfficeFilter): ent.SalesOffice[] {
        var cachedData: any = JSON.parse(localStorage.getItem('salesOffices'));
        var items = cachedData.x;
        var results: ent.SalesOffice[] = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i] as ent.SalesOffice;
            results.push(item);
        }
        if (filter.SalesOfficeTypeID) {
            var results = results.filter(x => x.SalesOfficeTypeID == filter.SalesOfficeTypeID);
        }
        return results;

    }

    getStates(): Observable<ent.State[]> {
        return this.httpClient.get<ent.State[]>(this.getStatesURL);
    }

    getDaysOfWeek(): Observable<ent.DayOfWeek[]> {
        return this.httpClient.get<ent.DayOfWeek[]>(this.getDaysOfWeekURL);
    }

    getRequestTypes(): Observable<ent.RequestType[]> {
        return this.httpClient.get<ent.RequestType[]>(this.getRequestTypesURL);
    }

    getRequestStatuses(): Observable<ent.RequestStatus[]> {
        return this.httpClient.get<ent.RequestStatus[]>(this.getRequestStatusesURL);
    }

    getDelayBetweenOrderAndDeliveries(): Observable<ent.DelayBetweenOrderAndDelivery[]> {
        return this.httpClient.get<ent.DelayBetweenOrderAndDelivery[]>(this.getDelayBetweenSalesAndDeliveriesURL);
    }

    getSections(): Observable<ent.Section[]> {
        return this.httpClient.get<ent.Section[]>(this.getSectionsURL);
    }

    getFeatures(): Observable<ent.Feature[]> {
        return this.httpClient.get<ent.Feature[]>(this.getFeaturesURL);
    }

    getShelfDirections(): Observable<ent.ShelfDirection[]> {
        return this.httpClient.get<ent.ShelfDirection[]>(this.getShelfDirectionsURL);
    }

    getProductSizes(): Observable<ent.ProductSize[]> {
        return this.httpClient.get<ent.ProductSize[]>(this.getProductSizesURL);
    }

    getVendSizeFlavorXrefs(filter: filters.VendSizeFlavorXrefsFilter): Observable<ent.VendSizeFlavorXref[]> {
        return this.httpClient.post<ent.VendSizeFlavorXref[]>(this.getVendSizeFlavorXrefsURL, filter);
    }

    getVendSizeFlavorXrefsFromCache(): ent.VendSizeFlavorXref[] {
        var cachedData: any = JSON.parse(localStorage.getItem('vendSizeFlavorXrefs'));
        var items = cachedData.x;
        var results: ent.VendSizeFlavorXref[] = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i] as ent.VendSizeFlavorXref;
            results.push(item)
        }
        return results;

    }

    getGlideTypes(): Observable<ent.GlideType[]> {
        return this.httpClient.get<ent.GlideType[]>(this.getGlideTypesURL);
    }

    getManagedBys(): Observable<ent.ManagedBy[]> {
        return this.httpClient.get<ent.ManagedBy[]>(this.getManagedBysURL);
    }

    getGlobalCustomers(): Observable<ent.GlobalCustomer[]> {
        return this.httpClient.get<ent.GlobalCustomer[]>(this.getGlobalCustomersURL);
    }

    getFullServiceCustomerTypes(): Observable<ent.FullServiceCustomerType[]> {
        return this.httpClient.get<ent.FullServiceCustomerType[]>(this.getFullServiceCustomerTypesURL);
    }

    getFullServicePricingTypes(): Observable<ent.FullServicePricingType[]> {
        return this.httpClient.get<ent.FullServicePricingType[]>(this.getFullServicePricingTypesURL);
    }

    getFullServicePackageConfigs(): Observable<ent.PackageConfig[]> {
        return this.httpClient.get<ent.PackageConfig[]>(this.getPackageConfigsURL);
    }

    getMassUpdateEntities(): Observable<ent.MassUpdateEntity[]> {
        return this.httpClient.get<ent.MassUpdateEntity[]>(this.getMassUpdateEntitiesURL);
    }

    getTables(): Observable<ent.Table[]> {
        return this.httpClient.get<ent.Table[]>(this.getTablesURL);
    }

    getTableAttributes(filter: filters.TableAttributeFilter): Observable<ent.TableAttribute[]> {
        return this.httpClient.post<ent.TableAttribute[]>(this.getTableAttributesURL, filter);
    }

    getDomainRecords(filter: filters.DomainRecordFilter): Observable<ent.DomainRecord[]> {
        return this.httpClient.post<ent.DomainRecord[]>(this.getDomainRecordsURL, filter);
    }

    getValidations(filter: filters.ValidationFilter): Observable<ent.Validation[]> {
        return this.httpClient.post<ent.Validation[]>(this.getValidationsURL, filter);
    }

    getValidationTypes(filter: filters.ValidationTypeFilter): Observable<ent.ValidationType[]> {
        return this.httpClient.post<ent.ValidationType[]>(this.getValidationTypesURL, filter);
    }

    getContactDepartments(filter: filters.ContactDepartmentFilter): Observable<ent.ContactDepartment[]> {
        return this.httpClient.post<ent.ContactDepartment[]>(this.getContactDepartmentsURL, filter);
    }

    getContactFunctions(filter: filters.ContactFunctionFilter): Observable<ent.ContactFunction[]> {
        return this.httpClient.post<ent.ContactFunction[]>(this.getContactFunctionsURL, filter);
    }

    getContactValidations(filter: filters.ContactValidationFilter): Observable<ent.ContactValidation[]> {
        return this.httpClient.post<ent.ContactValidation[]>(this.getContactValidationsURL, filter);
    }

    getCoolerDoors(filter: filters.CoolerDoorFilter): Observable<ent.CoolerDoor[]> {
        return this.httpClient.post<ent.CoolerDoor[]>(this.getCoolerDoorsURL, filter);
    }

    getCoolerStyles(filter: filters.CoolerStyleFilter): Observable<ent.CoolerStyle[]> {
        return this.httpClient.post<ent.CoolerStyle[]>(this.getCoolerStylesURL, filter);
    }

    getCreditHoldActions(filter: filters.CreditHoldActionFilter): Observable<ent.CreditHoldAction[]> {
        return this.httpClient.post<ent.CreditHoldAction[]>(this.getCreditHoldActionsURL, filter);
    }

    getCustomerOwnerships(): Observable<ent.CustomerOwnership[]> {
        return this.httpClient.get<ent.CustomerOwnership[]>(this.getCustomerOwnershipsURL);
    }

    getCustomerTypes(): Observable<ent.CustomerType[]> {
        return this.httpClient.get<ent.CustomerType[]>(this.getCustomerTypesURL);
    }

    getApprovalTypes(): Observable<ent.ApprovalType[]> {
        return this.httpClient.get<ent.ApprovalType[]>(this.getApprovalTypesURL);
    }

    getMasterDeliveryRoutes(): Observable<ent.MasterDeliveryRoute[]> {
        return this.httpClient.get<ent.MasterDeliveryRoute[]>(this.getMasterDeliveryRoutesURL);
    }

    getBillingDiscrepancyRequestTypes(filter: filters.BillingDiscrepancyRequestTypeFilter): Observable<ent.BillingDiscrepancyRequestType[]> {
        return this.httpClient.post<ent.BillingDiscrepancyRequestType[]>(this.getBillingDiscrepancyRequestTypesURL, filter);
    }

    getBillingDiscrepancyRequestReasons(filter: filters.BillingDiscrepancyRequestReasonFilter): Observable<ent.BillingDiscrepancyRequestReason[]> {
        return this.httpClient.post<ent.BillingDiscrepancyRequestReason[]>(this.getBillingDiscrepancyRequestReasonsURL, filter);
    }

    getBillingActions(filter: filters.BillingActionFilter): Observable<ent.BillingAction[]> {
        return this.httpClient.post<ent.BillingAction[]>(this.getBillingActionsURL, filter);
    }

    getCustomerPaymentTypes(filter: filters.BillingActionFilter): Observable<ent.CustomerPaymentType[]> {
        return this.httpClient.post<ent.CustomerPaymentType[]>(this.getCustomerPaymentTypesURL, filter);
    }

    getCustomerRoiTools(filter: filters.CustomerRoiToolFilter): Observable<ent.CustomerRoiTool[]> {
        return this.httpClient.post<ent.CustomerRoiTool[]>(this.getCustomerRoiToolsURL, filter);
    }

    getOutletAcquisitionTypes(filter: filters.OutletAcquisitionTypeFilter): Observable<ent.OutletAcquisitionType[]> {
        return this.httpClient.post<ent.OutletAcquisitionType[]>(this.getOutletAcquisitionTypesURL, filter);
    }

    getProspectSources(filter: filters.ProspectSourceFilter): Observable<ent.ProspectSource[]> {
        return this.httpClient.post<ent.ProspectSource[]>(this.getProspectSourcesURL, filter);
    }
    //#endregion

    //#region Save methods
    saveActivityReason(activityReason: ent.SaveActivityReasonRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveActivityReasonURL, activityReason);
    }

    saveContactValidation(contactValidation: ent.SaveContactValidationRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveContactValidationURL, contactValidation);
    }

    saveKeyAccount(keyAccount: ent.SaveKeyAccountRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveKeyAccountURL, keyAccount);
    }

    saveModel(model: ent.SaveModelRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveModelURL, model);
    }

    saveModelGroup(modelGroup: ent.SaveModelGroupRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveModelGroupURL, modelGroup);
    }

    savePrimaryGroupOverride(primaryGroupOverride: ent.SavePrimaryGroupOverrideRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.savePrimaryGroupOverrideURL, primaryGroupOverride);
    }

    saveRequestType(requestType: ent.SaveRequestTypeRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveRequestTypeURL, requestType);
    }

    saveSalesOffice(request: ent.SaveSalesOfficeRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveSalesOfficeURL, request);
    }

    saveVendSizeFlavorXref(vendSizeFlavorXref: ent.SaveVendSizeFlavorXrefRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveVendSizeFlavorXrefURL, vendSizeFlavorXref);
    }

    savePackageConfig(packageConfig: ent.SavePackageConfigRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.savePackageConfigURL, packageConfig);
    }

    saveDomainRecords(request: ent.SaveDomainRecordsRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveDomainRecordsURL, request);
    }
    //#endregion


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}

